import { render } from "./upload-item.vue?vue&type=template&id=318b7d50&scoped=true&lang=pug"
import script from "./upload-item.vue?vue&type=script&lang=js"
export * from "./upload-item.vue?vue&type=script&lang=js"

import "./upload-item.vue?vue&type=style&index=0&id=318b7d50&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318b7d50"]])

export default __exports__